import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import { project } from "@arcgis/core/geometry/projection";
import { buffer as geometryEngineBuffer } from "@arcgis/core/geometry/geometryEngine";
import Graphic from "@arcgis/core/Graphic";
import { useSelector } from 'react-redux';



const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";


    let gisrender;
    let dist_cd;
    let districtname;
    let ulb_cd;
    let ulbname;
    let layer;


const ChatAi = ({ view, map }) => {
    const [chats, setChats] = useState([]);
    const [userMessage, setUserMessage] = useState(null);
    const [isResponseGenerating, setIsResponseGenerating] = useState(false);
    const [theme, setTheme] = useState(localStorage.getItem("themeColor") || "light_mode");
    const chatContainerRef = useRef(null);
    const [showDeleteHistory, setShowDeleteHistory] = useState(false);
    const [activeVoice, setActiveVoice] = useState(false);
    const [geometry, setGeometory] = useState('');
    const [geometries, setGeometries] = useState(null);
    const { isTheme } = useSelector((state) => state.currentStage)
    const [isActive, setIsActive] = useState(false);
    const bufferGraphicRef = useRef(null);
    const bufferResponseFeaturesRef = useRef([]);
    const [dummy, setDummy] = useState("");
    const [bufferGraphic, setBufferGraphic] = useState(null);
    const [bufferResponseFeatures, setBufferResponseFeatures] = useState([]);
    const [objData, setObjData] = useState(null);
    const [tokenAuth, setTokenAuth] = useState(null);
    const [sessionId, setSessionId] = useState(null);
    const sessionIdRef = useRef(null)

    useEffect(() => {
        const token = localStorage.getItem("token");
        setTokenAuth(token)
    }, [])


    console.log("token22222", tokenAuth)
    const layers = [
        { name: "Roads", id: 45, outFields: ["*"] },
        { name: "Rivers", id: 69, outFields: ["ulb_cd ", "name", "area", "wardno"] },
        { name: "Railway", id: 56, outFields: ["ulb_cd ", "type", "dist_cd", "wardno"] },
        { name: "Important Land Marks", id: 79, outFields: ["ulb_cd", "name", "type"] },

    ];

    const Bufferlayers = [
        { name: "Plot Building Structure", id: 15, outFields: ["parcelno", "area", "wardno"] },
        { name: "Properties", id: 14, outFields: ["relation_id"] },
        { name: "Important Land Marks", id: 79, outFields: ["type", "name",] },
    ];

    // Clear all graphics from the view
    const clearAllGraphics = useCallback(() => {
        if (view) {
            view.graphics.removeAll();
            if (bufferGraphicRef.current) {
                bufferGraphicRef.current = null;
            }
            if (bufferResponseFeaturesRef.current.length) {
                bufferResponseFeaturesRef.current = [];
            }
        }
    }, [view]);

    useEffect(() => {
        if (geometries && objData) {
            console.log("Geometries updated, calling handleBufferButtonClick...");
            handleBufferButtonClick(objData);
        }
    }, [geometries, objData]);



    // Generate cache-busting URL parameter
    const getCacheBustingParam = () => `_cb=${Date.now()}`;

    const zoomToFeatureDistrict = useCallback(async (data) => {
        clearAllGraphics();

        const layer = new FeatureLayer({
            url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3?${getCacheBustingParam()}`,
            refreshInterval: 0
        });

        const query = new Query();
        query.where = `${"dist_cd"} = '${data?.dist_cd}'`;
        query.returnGeometry = true;
        query.returnDistinctValues = true;

        try {
            const response = await layer.queryFeatures(query);
            if (response.features && response.features.length > 0) {
                const geometry = response.features[0].geometry;
                const graphic = new Graphic({
                    geometry,
                    symbol: {
                        type: "simple-fill",
                        color: null,
                        outline: {
                            color: [0, 255, 255],
                            width: 2
                        }
                    }
                });

                view.graphics.add(graphic);

                view.goTo({
                    target: graphic.geometry.extent,
                    zoom: view.zoom + 4
                });
            } else {
                console.log("No features found for district:", data?.dist_cd);
            }
        } catch (error) {
            console.log("Error in zoomToFeatureDistrict:", error);
        }
    }, [view, clearAllGraphics]);

    const zoomToFeatureUlbs = useCallback(async (data) => {
        clearAllGraphics();

        const layer = new FeatureLayer({
            url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5?${getCacheBustingParam()}`,
            refreshInterval: 0
        });

        const query = new Query();
        query.where = `${"ulb_cd"} = '${data?.ulb_cd}'`;
        query.returnGeometry = true;
        query.returnDistinctValues = true;

        try {
            const response = await layer.queryFeatures(query);
            if (response.features && response.features.length > 0) {
                const geometry = response.features[0].geometry;
                const graphic = new Graphic({
                    geometry,
                    symbol: {
                        type: "simple-fill",
                        color: null,
                        outline: {
                            color: [0, 255, 255],
                            width: 2
                        }
                    }
                });

                view.graphics.add(graphic);

                view.goTo({
                    target: graphic.geometry.extent,
                    zoom: view.zoom + 8
                });
            } else {
                console.log("No features found for ULB:", data?.ulb_cd);
            }
        } catch (error) {
            console.log("Error in zoomToFeatureUlbs:", error);
        }
    }, [view, clearAllGraphics]);

    const highlightFeatures = useCallback((features) => {
        if (!features || features.length === 0) {
            console.log("No features found to highlight.");
            return;
        }

        const highlightGraphics = [];

        features.forEach((feature) => {
            if (!feature.geometry) {
                console.log("Feature has no geometry");
                return;
            }

            let highlightGraphic;
            const geometryType = feature.geometry.type;

            if (geometryType === "point") {
                highlightGraphic = new Graphic({
                    geometry: feature.geometry,
                    symbol: {
                        type: "simple-marker",
                        style: "circle",
                        color: [255, 0, 0, 0.5],
                        size: 8,
                        outline: { color: [255, 0, 0], width: 2 },
                    },
                });
            } else if (geometryType === "polyline") {
                highlightGraphic = new Graphic({
                    geometry: feature.geometry,
                    symbol: {
                        type: "simple-line",
                        color: [255, 0, 0],
                        width: 3,
                    },
                });
            } else if (geometryType === "polygon") {
                highlightGraphic = new Graphic({
                    geometry: feature.geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [255, 0, 0, 0.3],
                        outline: { color: [255, 0, 0], width: 2 },
                    },
                });
            } else {
                console.log(`Unsupported geometry type: ${geometryType}`);
                return;
            }

            view.graphics.add(highlightGraphic);
            highlightGraphics.push(highlightGraphic);
        });

        // Zoom to highlighted features
        if (features[0]?.geometry) {
            view.goTo(features.map((feature) => feature.geometry?.extent?.expand(1.5)))
                .catch(err => console.log("Error zooming:", err));
        }

        return highlightGraphics;
    }, [view]);

    const handleLayerChange = useCallback(async (data) => {
        try {
            // Determine layer and output fields based on data.layer
            let layerValue, outValue;

            if (data?.layer === "Roads") {
                layerValue = "45";
                outValue = ["*"];
            } else if (data?.layer === "Rivers") {
                layerValue = "69";
                outValue = ["ulb_cd", "name", "area", "wardno"];
            } else if (data?.layer === "Railway") {
                layerValue = "56";
                outValue = ["ulb_cd", "type", "dist_cd", "wardno"];
            } else if (data?.layer === "Important Land Marks") {
                layerValue = "76";
                outValue = ["ulb_cd", "name", "type"];
            } else {
                console.log("Unknown layer:", data?.layer);
                return;
            }

            // Create feature layer with cache-busting parameter
            const layer = new FeatureLayer({
                url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerValue}?${getCacheBustingParam()}`,
                refreshInterval: 0
            });

            const query = new Query();
            query.where = `dist_cd = '${data?.dist_cd}' AND ulb_cd = '${data?.ulb_cd}'`;
            query.returnGeometry = true;
            query.outFields = outValue;
            query.returnDistinctValues = true;

            const response = await layer.queryFeatures(query);
            if (!response.features.length) {
                console.log("No features returned for the selected layer.");
                return;
            }

            // Clear existing graphics before adding new ones
            clearAllGraphics();

            console.log("")

            // Process and add features to the map
            response.features.forEach((feature) => {
                if (!feature.geometry) return;

                let graphic;
                const geometryType = feature.geometry.type;

                if (geometryType === "point") {
                    graphic = new Graphic({
                        geometry: feature.geometry,
                        symbol: {
                            type: "simple-marker",
                            style: "circle",
                            color: [0, 0, 255, 0.5],
                            size: 6,
                            outline: { color: [0, 0, 255], width: 1 },
                        },
                    });
                } else if (["polyline", "multiline", "multipolyline"].includes(geometryType)) {
                    graphic = new Graphic({
                        geometry: feature.geometry,
                        symbol: { type: "simple-line", color: [0, 255, 0], width: 2 },
                    });
                } else if (["polygon", "multipolygon"].includes(geometryType)) {
                    graphic = new Graphic({
                        geometry: feature.geometry,
                        symbol: {
                            type: "simple-fill",
                            color: [255, 255, 0, 0.5],
                            outline: { color: [255, 255, 0], width: 1 },
                        },
                    });
                } else {
                    console.log(`Unsupported geometry type: ${geometryType}`);
                    return;
                }

                view.graphics.add(graphic);
            });

            // Zoom to the first feature
            const firstFeature = response.features[0];
            if (firstFeature?.geometry) {
                const center = firstFeature.geometry.centroid || firstFeature.geometry.extent?.center;
                if (center) {
                    view.goTo(center);
                }
            }

            // Proceed to field value change operation with a delay to prevent race conditions
            setTimeout(() => {
                handleFieldValueChange(data, layerValue);
            }, 500);

        } catch (error) {
            console.log("Error fetching or processing layer data:", error);
        }
    }, [view, clearAllGraphics]);

    // const handleLayerProTax = useCallback(async (data) => {
    //     try {
    //         // Determine comparison operator dynamically
    //         let comparisonOperator;
    //         switch (data?.operator) {
    //             case "Greater":
    //                 comparisonOperator = ">=";
    //                 break;
    //             case "Less":
    //                 comparisonOperator = "<=";
    //                 break;
    //             case "Equal":
    //             default:
    //                 comparisonOperator = "=";
    //                 break;
    //         }

    //         // Construct query parameters
    //         const whereClause = `ulb_cd='${data?.ulb_cd}' AND wardno='${data?.wardno}' AND ptaxvalue${comparisonOperator}${data?.ptaxvalue}`;
    //         const encodedWhereClause = encodeURIComponent(whereClause);

    //         const urlSearch = `https://urbangis.mp.gov.in/server/rest/services/temp_n/property_tax_status/FeatureServer/98/query?where=${encodedWhereClause}&outFields=*&returnGeometry=false&f=json`;

    //         console.log("Fetching URL:", urlSearch);

    //         // Fetch data from API
    //         const response = await fetch(urlSearch);
    //         if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    //         const responseData = await response.json();
    //         console.log("API Response:", responseData?.features);

    //     } catch (error) {
    //         console.log("Error fetching or processing layer data:", error);
    //     }
    // }, []);

    const handleLayerProTax = useCallback(async (data) => {
        try {
            let urlSearch;

            if (["Greater", "Less", "Equal"].includes(data?.operator)) {
                // Determine comparison operator dynamically
                let comparisonOperator;
                switch (data?.operator) {
                    case "Greater":
                        comparisonOperator = ">=";
                        break;
                    case "Less":
                        comparisonOperator = "<=";
                        break;
                    case "Equal":
                    default:
                        comparisonOperator = "=";
                        break;
                }

                // Construct query parameters
                const whereClause = `ulb_cd='${data?.ulb_cd}' AND wardno='${data?.wardno}' AND ptaxvalue${comparisonOperator}${data?.ptaxvalue}`;
                const encodedWhereClause = encodeURIComponent(whereClause);

                urlSearch = `https://urbangis.mp.gov.in/server/rest/services/temp_n/property_tax_status/FeatureServer/98/query?where=${encodedWhereClause}&outFields=*&returnGeometry=false&f=json`;

                console.log("Fetching URL:", urlSearch);

                // Fetch data from API
                const response = await fetch(urlSearch);
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                const responseData = await response.json();



                const relationIds = (responseData?.features ?? [])
                    .map(feature => feature.attributes?.relation_id)
                    .filter(Boolean)
                    .map(id => `'${id}'`)
                    .join(", ");

                console.log("API Response:", responseData?.features || responseData);
                console.log("relationIds:", relationIds);

                // setChats(prevChats => [...prevChats, relationIds]);
                console.log()
                if (relationIds.trim()) {
                    setDummy(relationIds);
                }



                // await handleGetInfo(relationIds, data);

            } else if (["Min", "Max"].includes(data?.operator)) {
                // Call different API for Min/Max
                const minMaxOperator = data?.operator === "Min" ? "min" : "max";
                urlSearch = `https://urbangis.mp.gov.in/server/rest/services/temp_n/property_tax_status/FeatureServer/98/query?where=ulb_cd%3D%27${data?.ulb_cd}%27+and+ptaxvalue!=0&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&defaultSR=&spatialRel=esriSpatialRelRelation&distance=&units=esriSRUnit_Foot&relationParam=&outFields=&returnGeometry=true&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=wardno&outStatistics=%5B%7B%22statisticType%22%3A%22${minMaxOperator}%22%2C+%22onStatisticField%22%3A+%22ptaxvalue%22%2C+%22outStatisticFieldName%22%3A+%22output_value%22%7D%0D%0A%5D&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnCentroid=false&timeReferenceUnknownClient=false&maxRecordCountFactor=&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&cacheHint=false&f=json`;

                console.log("urlSearch")
                const response = await fetch(urlSearch);
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                const responseData = await response.json();

                const wardData = responseData.features.find(item => item.attributes.wardno === data?.wardno);

                if (wardData) {
                    const whereClause = `ulb_cd='${data?.ulb_cd}' AND wardno='${data?.wardno}' AND ptaxvalue${"="}${wardData?.attributes?.output_value}`;
                    const encodedWhereClause = encodeURIComponent(whereClause);

                    urlSearch = `https://urbangis.mp.gov.in/server/rest/services/temp_n/property_tax_status/FeatureServer/98/query?where=${encodedWhereClause}&outFields=*&returnGeometry=false&f=json`;

                    console.log("Fetching URL:", urlSearch);

                    // Fetch data from API
                    const response = await fetch(urlSearch);
                    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                    const responseData = await response.json();
                    console.log("API Final Reponse:", responseData?.features || responseData);
                }

                console.log("API Response:", responseData?.features || responseData);
                console.log("wardData", wardData);

            } else {
                console.log("Invalid operator:", data?.operator);
                return;
            }



        } catch (error) {
            console.log("Error fetching or processing layer data:", error);
        }
    }, []);

    // const handleGetInfo = async (relationIds, data) => {
    //     try {

    //         const info = {
    //             ulbCode: ulbCode,
    //             wardCode: wardCode,
    //             mobileno: selectedSearch === "Mobile Number" ? searchInput : "",
    //             ownername: selectedSearch === "Owner Name" ? searchInput : "",
    //             e_nagarpalikaid: selectedSearch === "e_NagarPalika ID" ? searchInput : "",
    //             relation_id: selectedSearch === "relation_id" ? searchInput : "",
    //         };

    //         console.log("infoinfo",info)

    //         if (info?.relation_id) {
    //             getNewTableData(info);
    //             return; // Stop execution (no need to proceed with the API call)
    //         }

    //         if (!info.mobileno && !info.ownername && !info.e_nagarpalikaid) {
    //             console.log("No search criteria provided. API call skipped.");
    //             return; // Stop execution
    //         }




    //         let queryParams = [];

    //         if (info.ulbCode) queryParams.push(`ulb_cd%3D%27${info.ulbCode}%27`);
    //         if (info.wardCode) queryParams.push(`wardno%3D%27${info.wardCode}%27`);
    //         if (info.mobileno) queryParams.push(`mobileno%3D%27${info.mobileno}%27`);
    //         if (info.ownername) queryParams.push(`ownername%3D%27${info.ownername}%27`);
    //         if (info.e_nagarpalikaid) queryParams.push(`e_nagarpalikaid%3D%27${info.e_nagarpalikaid}%27`);


    //         const whereClause = queryParams.join("+and+");




    //         const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/FeatureServer/96/query?where=${whereClause}&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&defaultSR=&spatialRel=esriSpatialRelRelation&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnCentroid=false&timeReferenceUnknownClient=false&maxRecordCountFactor=&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&cacheHint=false&f=geojson`;




    //         // console.log("selectedSearchProperty:", districtCode, ulbCode, wardCode, searchInput);
    //         // console.log("Info:", info);

    //         // const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/FeatureServer/96/query?where=ulb_cd%3D%27${info?.ulbCode}%27+and+wardno%3D%27${info?.wardCode}%27+and+e_nagarpalikaid%3D%27${info?.e_nagarpalikaid}%27&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&defaultSR=&spatialRel=esriSpatialRelRelation&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnCentroid=false&timeReferenceUnknownClient=false&maxRecordCountFactor=&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&cacheHint=false&f=geojson`


    //         console.log("url", url)
    //         const response = await fetch(url);
    //         const data = await response.json();
    //         console.log("datadatadatadata", data)
    //         if (data.features && data.features.length > 0) {
    //             // Convert features into an array of objects
    //             const propertyData = data.features.map(feature => ({
    //                 relation_id: feature.properties.relation_id || "N/A",
    //                 ownername: feature.properties.ownername || "N/A",
    //                 pin: feature.properties.pin || "N/A",
    //                 mobileno: feature.properties.mobileno || "N/A",
    //                 nooffloor: feature.properties.nooffloor || "N/A",
    //                 property: feature.properties.property || "N/A",
    //                 Photo: feature.properties.photolink || "N/A"
    //             }));
    //             const uniquePropertyData = Array.from(new Map(propertyData.map(item => [item.relation_id, item])).values());
    //             // setPropertyInfo(propertyData); // Store as an array of objects
    //             setPropertyInfo(uniquePropertyData);
    //             console.log("setPropertyInfosetPropertyInfo", propertyData)
    //         } else {
    //             setPropertyInfo([]); // No data found, set an empty array
    //         }

    //         // Highlight features on the map
    //         if (data.features && data.features.length > 0) {
    //             const relationIds = data.features.map(feature => feature.properties.relation_id);
    //             if (relationIds.length > 0) {
    //                 highlightFeatures2(relationIds,data);
    //             }
    //         }

    //     } catch (error) {
    //         console.log("Error in handleGetInfo:", error);
    //         setPropertyInfo([]); // Set empty array on error
    //     }
    // };

    // const highlightFeatures2 = async (relationIds,data) => {
    //     try {
    //         const featureLayer = new FeatureLayer({
    //             url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/14"
    //         });

    //         const query = new Query();
    //         query.where = ulb_cd =  `relation_id IN (${relationIds})`;
    //         query.returnGeometry = true;
    //         query.outFields = ["relation_id"];

    //         const response = await featureLayer.queryFeatures(query);
    //         // console.log("Matched Features:", response.features);

    //         if (response.features.length > 0) {
    //             const graphics = response.features.map(feature => new Graphic({
    //                 geometry: feature.geometry,
    //                 symbol: {
    //                     type: "simple-fill",
    //                     color: [0, 255, 0, 0.5], // green with transparency
    //                     outline: {
    //                         color: [255, 0, 0],
    //                         width: 2
    //                     }
    //                 }
    //             }));

    //             view.graphics.removeAll();
    //             graphics.forEach(graphic => view.graphics.add(graphic));
    //             view.goTo(response.features.map(f => f.geometry.extent).reduce((acc, cur) => acc.union(cur)));
    //         }
    //     } catch (error) {
    //         console.log("Error in highlightFeatures:", error);
    //     }
    // };






    const handleBufferButtonClick = useCallback(async (data) => {
        if (bufferGraphic) {
            view.graphics.remove(bufferGraphic);
            setBufferGraphic(null);
        }

        if (bufferResponseFeatures?.length) {
            bufferResponseFeatures.forEach(feature => view.graphics.remove(feature));
        }

        const spatialReference = new SpatialReference({ wkid: 3857 });
        const projectedGeometry = project(geometries, spatialReference);
        if (!projectedGeometry) return console.log("Failed to project geometry.");

        const unitMap = { meters: "meters", kilometers: "kilometers", miles: "miles" };
        const unit = unitMap[data.unit];

        const bufferGeometry = geometryEngineBuffer(projectedGeometry, parseFloat(data.bufferDistance), unit);
        if (!bufferGeometry) return console.log("Failed to create buffer.");

        const _bufferGraphic = new Graphic({
            geometry: bufferGeometry,
            symbol: { type: "simple-fill", color: null, outline: { color: [0, 0, 255], width: 2 } },
        });


        view.graphics.add(_bufferGraphic);
        setBufferGraphic(_bufferGraphic);

        let bufferData = [];
        let graphics = [];
        let allFeatures = [];
        let allRelationIds = [];


        await Promise.all(Bufferlayers.map(async (bufferLayer) => {
            const bufferLayerInstance = new FeatureLayer({
                url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${bufferLayer.id}`,
            });

            const bufferQuery = new Query({
                geometry: bufferGeometry,
                //spatialRelationship:obj.spatialRelation,
                returnGeometry: true,
                outFields: bufferLayer.outFields,
            });

            const bufferResponse = await bufferLayerInstance.queryFeatures(bufferQuery);
            const features = bufferResponse?.features || [];

            bufferData.push({ layer: bufferLayer.name, features: features.map(f => f.attributes) });

            console.log("bufferDatabufferData", bufferData)

            allFeatures.push(...features);

            // Add Graphics
            features.forEach(feature => {
                const symbolMap = {
                    point: { type: "simple-marker", style: "circle", color: [255, 0, 0, 0.5], size: 6, outline: { color: [0, 0, 0, 1], width: 1 } },
                    polyline: { type: "simple-line", color: [0, 255, 0, 0.5], width: 2 },
                    polygon: { type: "simple-fill", color: [128, 255, 0, 0.5], outline: { color: [0, 0, 0, 1], width: 1 } },
                    multipolygon: { type: "simple-fill", color: [255, 0, 255, 0.5], outline: { color: [0, 0, 0, 1], width: 1 } },
                };

                if (!symbolMap[feature.geometry.type]) return;

                const graphic = new Graphic({ geometry: feature.geometry, symbol: symbolMap[feature.geometry.type] });
                graphics.push(graphic);
                view.graphics.add(graphic);
            });
        }));

        setBufferResponseFeatures(graphics);
        //  dispatch(setFeatureTable(bufferData));




    }, [geometries]);




    const handleFieldValueChange = useCallback(async (data, layerValue) => {
        try {
            if (!data?.values || !data?.dist_cd || !data?.ulb_cd) {
                console.log("Missing required parameters for field value change");
                return;
            }

            const layer = new FeatureLayer({
                url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerValue}?${getCacheBustingParam()}`,
                refreshInterval: 0
            });

            const query = new Query();
            query.where = `dist_cd = '${data?.dist_cd}' AND ulb_cd = '${data?.ulb_cd}' AND name = '${data?.values}'`;
            query.returnGeometry = true;
            query.returnDistinctValues = true;

            const response = await layer.queryFeatures(query);
            if (!response.features || response.features.length === 0) {
                console.log("No features found for field value:", data?.values);
                return;
            }

            if (response) {
                setIsActive(true);
            }

            try {
                const response = await layer.queryFeatures(query);
                if (response.geometryType === "polyline") {
                    let paths = [];
                    response.features.forEach((featutre) => {
                        featutre.geometry.paths.forEach((path) => {
                            paths.push(path);
                        });
                    });

                    var polyline = {
                        type: "polyline",
                        paths: paths,
                        spatialReference: { wkid: 4326 }
                    };
                    var feature = new Graphic({
                        geometry: polyline,
                    });
                    setGeometory(polyline);
                    highlightFeatures([feature]);
                } else {
                    setGeometory(response.features[0].geometry);
                    highlightFeatures(response.features);
                }

            } catch (error) {
                console.log("Error querying features:", error);
            }

        } catch (error) {
            console.log("Error querying features:", error);
        }
    }, [highlightFeatures]);







    // Initialize and cleanup graphics layer
    // useEffect(() => {
    //     if (view) {
    //         const layer = new GraphicsLayer({
    //             id: "chatAiGraphicsLayer"
    //         });
    //         view.map.add(layer);
    //         graphicsLayerRef.current = layer;
    //         setPointLayer(layer);

    //         // Return cleanup function
    //         return () => {
    //             if (layer) {
    //                 view.map.remove(layer);
    //             }
    //             clearAllGraphics();
    //         };
    //     }
    // }, [view, clearAllGraphics]);

    // Load chat data from localStorage
    useEffect(() => {
        loadDataFromLocalstorage();
    }, []);

    // Auto-scroll chat container on new messages
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTo({
                top: chatContainerRef.current.scrollHeight,
                behavior: 'smooth'
            });
        }
    }, [chats]);

    // Load data from local storage
    const loadDataFromLocalstorage = () => {
        try {
            const savedChats = localStorage.getItem("saved-chats");
            if (savedChats) {
                setChats(JSON.parse(savedChats));
                document.body.classList.add("hide-header");
            }
            applyTheme(localStorage.getItem("themeColor") || "light_mode");
        } catch (error) {
            console.log("Error loading data from localStorage:", error);
            // Fallback to empty chats if localStorage data is corrupted
            setChats([]);
        }
    };

    // console.log("gsdjhfjhsdfcdsjhfsdjhf", chats)

    const applyTheme = (themeColor) => {
        setTheme(themeColor);
        localStorage.setItem("themeColor", themeColor);
        document.body.classList.toggle("light_mode", themeColor === "light_mode");
    };

    // Create a new message element
    const createMessage = (content, type, loading = false, error = false) => {
        return { type, content, loading, error, id: Date.now() };
    };

    // Show typing effect
    const showTypingEffect = (text, messageId) => {
        console.log("texttexttext", text)
        if (!text) {
            text = "";
        }

        return new Promise((resolve) => {
            const words = text.split(' ').filter(word => word.trim() !== "");
            let currentWordIndex = 0;

            const typingInterval = setInterval(() => {
                setChats((prevChats) => {
                    const updatedChats = prevChats.map((chat) =>
                        chat.id === messageId
                            ? { ...chat, content: chat.content + (currentWordIndex === 0 ? '' : ' ') + words[currentWordIndex] }
                            : chat
                    );

                    if (currentWordIndex >= words.length - 1) {
                        clearInterval(typingInterval);
                        setIsResponseGenerating(false);

                        try {
                            localStorage.setItem("saved-chats", JSON.stringify(updatedChats));
                        } catch (error) {
                            console.log("Error saving chats to localStorage:", error);
                        }
                        resolve();
                    }

                    currentWordIndex++;
                    return updatedChats;
                });
            }, 75);
        });
    };
    const API_KEY = process.env.REACT_APP_AUTH_KEY;
    const API_URL = process.env.REACT_APP_API_AI_URL;




    const hadleGetRoad = async (data) => {

        const layerDetails = layers.find(layer => layer.name === data.layer);
        if (!layerDetails) return;

        const layer = new FeatureLayer({
            url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerDetails.id}`,
        });

        const query = new Query();
        query.where = `dist_cd = '${data.dist_cd}' AND ulb_cd = '${data.ulb_cd}' AND ${data.fields} = '${data.values}'`;
        query.returnGeometry = true;

        try {
            const response = await layer.queryFeatures(query);
            if (response.geometryType === "polyline") {
                let paths = [];
                response.features.forEach((featutre) => {
                    featutre.geometry.paths.forEach((path) => {
                        paths.push(path);
                    });
                });

                var polyline = {
                    type: "polyline",
                    paths: paths,
                    spatialReference: { wkid: 4326 }
                };
                var feature = new Graphic({
                    geometry: polyline,
                });
                setGeometries(polyline);
                highlightFeatures([feature]);
            } else {
                setGeometries(response.features[0].geometry);
                highlightFeatures(response.features);
            }

       


        } catch (error) {
            console.log("Error querying features:", error);
        }
    };




 
    function escapeHtml(str) {
        return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    const generateAPIResponse = async (message, messageId) => {
        if (!message) return
        setDummy("");
        setShowDeleteHistory(true);

        const bodyPayload = {
            query: message,
            ...(sessionIdRef.current && { session_id: sessionIdRef.current })
        };

        try {
            const response = await fetch(API_URL, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${tokenAuth}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bodyPayload),
            });

            const result = await response.json();

            const data = result?.response;
            const receivedSessionId = result?.session_id;


  const strgis_data = result?.gis_data;

            /*
"gis_data": {
    "gisrender": true,
    "dist_cd": "419",
    "districtname": "Morena",
    "ulb_cd": "0141",
    "ulbname": "Morena",
    "layer": "Property"
}

*/           gisrender = result?.gisrender;
            dist_cd = strgis_data.dist_cd;
            districtname = strgis_data.districtname;
            ulb_cd = strgis_data.ulb_cd;
            ulbname = strgis_data.ulbname;
            layer = strgis_data.layer; 

             LoadZoom();
              if (gisrender === true) {
               
            }


     

           

//loadzoom()

            console.log("Response:", data);
            console.log("Session ID:", receivedSessionId);

            if (receivedSessionId) {
                sessionIdRef.current = receivedSessionId;
            }

            if (data?.dist_cd) await zoomToFeatureDistrict(data);
            if (data?.ulb_cd) await zoomToFeatureUlbs(data);

            if (data?.responsefor === "properttax") {
                await handleLayerProTax(data);
            } else {
                await hadleGetRoad(data);
                setObjData(data);
            }

            // Replace \n with actual line breaks
            const apiResponse = escapeHtml((typeof data === 'string' ? data : JSON.stringify(data, null, 2)))
                .replace(/\\n/g, '\n')
                .replace(/\n/g, '<br />');

            console.log("apiResponseapiResponse", apiResponse)
            // Show loading effect
            setChats(prevChats =>
                prevChats.map(chat =>
                    chat.id === messageId ? { ...chat, content: "", loading: true } : chat
                )
            );

            await showTypingEffect(apiResponse, messageId);

            setChats(prevChats =>
                prevChats.map(chat =>
                    chat.id === messageId ? { ...chat, loading: false } : chat
                )
            );

        } catch (error) {
            console.error("API call failed:", error);
            setChats(prevChats =>
                prevChats.map(chat =>
                    chat.id === messageId
                        ? { ...chat, content: "Error occurred while fetching response.", loading: false }
                        : chat
                )
            );
        }
    };




    const showLoadingAnimation = () => {
        const loadingMessage = createMessage(
            `<div class="message-content">
                <img class="avatar" src="img/ai-garud-logo.png" alt="Gemini avatar" />
                <p class="text m-0"></p>
                <div class="loading-indicator">
                    <div class="loading-bar"></div>
                    <div class="loading-bar"></div>
                </div>
            </div>`,
            "incoming",
            true
        );

        setChats(prevChats => [...prevChats, loadingMessage]);
        return loadingMessage; // Return the message object
    };


    // Copy message to clipboard
    const copyMessage = (messageContent) => {
        navigator.clipboard.writeText(messageContent);
    };

    // Handle outgoing chat
    const handleOutgoingChat = (message) => {
        if (!message) return;
        // ✅ Create outgoing message
        const outgoingMessage = createMessage(
            `<div class="message-content">
                <p class="text m-0">${message}</p>
            </div>`,
            "outgoing"
        );

        setChats(prevChats => [...prevChats, outgoingMessage]);

        // ✅ Only clear input if message was typed
        if (message === userMessage) {
            setUserMessage(''); // Clears input field after sending
        }

        document.body.classList.add("hide-header");

        // ✅ Show loading animation & call API
        setTimeout(() => {
            const loadingMessage = showLoadingAnimation();
            generateAPIResponse(message, loadingMessage.id);
        }, 500);
    };





    // Handle theme toggle
    const handleThemeToggle = () => {
        const newTheme = theme === "light_mode" ? "dark_mode" : "light_mode";
        applyTheme(newTheme);
    };

    // Handle delete chats
    const handleDeleteChats = () => {
        // if (window.confirm("Are you sure you want to delete all the chats?")) {
        handleRefresh()
        sessionIdRef.current = null;
        localStorage.removeItem("saved-chats");
        setChats([]);
        document.body.classList.remove("hide-header");
        setDummy("")
        // }
    };

    // Handle suggestion click
    const handleSuggestionClick = (suggestionText) => {
        setUserMessage(suggestionText);
        handleOutgoingChat();
    };

    // Handle form submit
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        await handleRefresh()
        // ✅ Ensure the typed input is sent correctly

        if (userMessage.trim() !== '') {

            handleOutgoingChat(userMessage);
// Bhupen 27AUG
            // gisrender = true;
            // dist_cd = '419';
            // districtname = 'Morena';
            // ulb_cd = '0141';
            // ulbname = 'Morena';

        }


    };




 const LoadZoom = () => {
        //  alert(`Card Title on MAP: ${selectedTitle}`);
        if (ulbname && ulb_cd) {
            zoomToUlb(ulbname);
        } else if (districtname && dist_cd) {
            zoomToDistrict(districtname);
        }
    };


    const zoomToUlb = async (ulbName) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/5')}` });
        const query = new Query({ where: `name = '${ulbName}'`, returnGeometry: true });

        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 0, 255], width: 2 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.5));
            }
        } catch (error) {
            console.error("Error zooming to ULB:", error);
        }
    };



    const zoomToDistrict = async (districtName) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/3')}` });
        const query = new Query({ where: `districtname = '${districtName}'`, returnGeometry: true });
        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 255, 0], width: 2.0 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.0));
            }
        } catch (error) {
            console.error("Error zooming to district:", error);
        }
    };








    const handleChange = (e) => {
        e.target.style.height = 'auto'; // Reset height
        document.getElementById("send-message-button").disabled = false;

        console.log("e.target.value", e.target.value)
        e.target.style.height = e.target.scrollHeight + 'px'; // Set height based on content
        setUserMessage(e.target.value)
    }

    const handleVoice = () => {
        if (activeVoice) {
            setActiveVoice(false);
            if (window.recognition) {
                window.recognition.stop();
            }
            return;
        }

        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            console.error("Speech Recognition is not supported in this browser.");
            return;
        }

        setActiveVoice(true);
        const recognition = new SpeechRecognition();
        recognition.lang = "en-US";
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        window.recognition = recognition;

        recognition.onresult = (event) => {
            const voiceText = event.results[0][0].transcript;
            console.log("Recognized Speech:", voiceText);
            // ONLY set the text in the input field. Do NOT submit.
            setUserMessage(voiceText);
        };

        recognition.onerror = (event) => {
            console.error("Speech recognition error:", event.error);
            setActiveVoice(false);
        };

        recognition.onend = () => {
            setActiveVoice(false);
        };

        recognition.start();
    };

    const handleRefresh = () => {
        view.graphics.removeAll();
        view.goTo({
            center: [77.4126, 23.2599], // Longitude, Latitude
            zoom: 6 // Adjust zoom level as needed
        });
    }




    return (
        <div >


            <div className={`gisaiheaderdiv ${showDeleteHistory ? 'gisaiheaderdivboarder' : ''}`}
            style={{
                  background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)",
            }}
            >
                <div> 
                    {/* <h6 className='gis-title m-0'>GIS AI</h6> */}
                    <img  src='img/gis-garud-masked.png' height="40px" alt='ai'/>
                </div>
                <div className='ai-headdiv'>
                    <div className={`delete-history-container ${showDeleteHistory || chats.length > 0 ? 'show' : ''}`}>
                        <button className='btn-danger-ai' onClick={handleDeleteChats}>
                            {isTheme === "light" ? <img src="img/messagedelete.svg" alt='ai' /> :
                                <img src="img/trashbin.svg" alt='ai' />}Clear this Chat
                        </button>
                    </div>
                    <button className='btn-info-ai' onClick={() => handleRefresh()}>
                        <img src="img/refreshlight.svg" alt="refresh" width="20px" height="20px" />
                        Refresh</button>
                    <Link to="/chat-history" style={{ textDecoration: "none" }}>
                        <button className='btn-info-ai'>
                            <img src="img/historyai.svg" alt='ai' />History
                        </button>
                    </Link>
                </div>
            </div>
            <div className="header container-ai">
                <p className="subtitle">How can I assist you with GIS
                    <br />
                    insights today? 🌍 </p>
                <h6 className='title'>Suggestions</h6>
                <div className="row suggestion-list" style={{ rowGap: "12px" }}>
                    <div className="col-md-4" onClick={() => handleSuggestionClick("How many rivers in bhopal.")}>
                        <div className='suggestion'>
                            <span >
                                {isTheme === "light" ? <img src="img/expand-arrows-light.svg" alt='expand' /> :
                                    <img src="img/expand-arrows.svg" alt='expand' />}
                            </span>
                            <h4 className="text">How many rivers in bhopal.</h4>
                        </div>
                    </div>
                    <div className="col-md-4" onClick={() => handleSuggestionClick("What are ULBs of Rewa?")}>
                        <div className='suggestion'>
                            <span >
                                {isTheme === "light" ? <img src="img/expand-arrows-light.svg" alt='expand' /> :
                                    <img src="img/expand-arrows.svg" alt='expand' />}
                            </span>
                            <h4 className="text">What are ULBs of Rewa?</h4>
                        </div>
                    </div>
                    <div className="col-md-4" onClick={() => handleSuggestionClick("what are major roads in chakghat?")}>
                        <div className='suggestion'>
                            <span >
                                {isTheme === "light" ? <img src="img/expand-arrows-light.svg" alt='expand' /> :
                                    <img src="img/expand-arrows.svg" alt='expand' />}
                            </span>
                            <h4 className="text">what are major roads in chakghat?</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div className="chat-list" ref={chatContainerRef}>
                {chats.map((chat) => (
                    <div key={chat.id} className={`message ${chat.type} ${chat.loading ? 'loading' : ''} ${chat.error ? 'error' : ''}`}>
                        <div dangerouslySetInnerHTML={{ __html: chat.content }} />
                        {!chat.loading && !chat.error && chat.type !== 'outgoing' && (
                            <span className="icon material-symbols-rounded" onClick={() => copyMessage(chat.content)}>
                            </span>
                        )}
                    </div>
                ))}
                {dummy &&
                    <div className='row'>
                        <div className='col-md-12'> <h4 className='link-text m-0'>The following properties are available</h4></div>
                        <div className='col-md-12'> <h4 className='link-text m-0'>`${dummy}`</h4></div>
                    </div>
                }
            </div>

            <div className="typing-area">
                <form className="typing-form" onSubmit={handleFormSubmit}>
                    <div className={activeVoice ? "input-wrapper-active" : "input-wrapper"}>
                        <textarea
                            placeholder="Enter any your Query"
                            className="form-control typing-input"
                            required
                            value={userMessage || ''}
                            onChange={(e) => handleChange(e)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleFormSubmit(e);
                                }
                            }}
                            rows={1}
                        />

                    </div>
                    <div className='ai-voicebtndiv'>
                        <button id="send-message-button" className="icon material-symbols-rounded" type="submit">
                            <img src="img/up-arrowai.svg" alt='arrow' />
                        </button>
                        <button
                            id="voice-btn"
                            type="button" // Prevents form submission
                            onClick={handleVoice}
                            className={activeVoice ? 'active-voice-btn' : ''}
                        >
                            {userMessage ? <img src="img/voicemessage.svg" alt="arrow" width="40px" height="40px" /> :
                                <>
                                    <img src="img/voicemessage.svg" alt="arrow" width="40px" height="40px" />
                                    <span className='voice-text-sm'>{activeVoice ? 'Go ahead I’m Listening' : 'Use AI Voice search'}</span>
                                    {activeVoice && <img src="img/crossvoice.svg" alt="ai" width="12px" className='mx-2' height="12px" />}</>
                            }
                        </button>
                    </div>
                </form>
                <p className="disclaimer-text">
                    GIS software may display inaccurate or outdated information, including spatial data and analytics, so verify results before making decisions. Your privacy and GIS applications are important—ensure data security and compliance with best practices.
                </p>
            </div>
        </div>
    );
};

export default ChatAi;
